import styled from "styled-components";
import Button from "../../../atoms/Button";

export const Container = styled.div`
  display: flex;
  padding: 24px;

  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
  justify-content: flex-end;
  border-radius: 16px;
  min-height: ${(props) => (props.isSmallScreen ? "295px" : "374px")};
  border-radius: var(--radius-small, 16px);
  background: ${(props) =>
    `linear-gradient(0deg, #1F2D3D 29.72%, rgba(31, 45, 61, 0.00) 99.74%), url(${props.background}), lightgray 50% / cover no-repeat`};
  //background-repeat: no-repeat;
  background-size: 100%;
`;

export const ButtonHighlight = styled(Button)`
  width: 100%;
  min-height: 44px;
  margin-top: 24px;
`;

export const Title = styled.span`
  color: ${(props) => props.color || "white"};
  font-size: ${(props) => props.fontSize || "12px"};
  line-height: 16px;
  text-overflow: ellipsis;
`;

export const Typography = styled.h3`
  color: ${(props) => props.color || "white"};
  font-family: Gilroy;
  font-size: ${(props) => props.fontSize || "24px"};
  font-style: normal;
  margin-bottom: 0;
  letter-spacing: 0.2px;
`;

export const H2Typography = styled.h2`
  margin-bottom: ${(props) => props.marginBottom || "8px"};
  line-height: 2.4rem;
`;
